var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1924 0H3.80761L0 3.80761V9.1924L3.80761 13H9.1924L13 9.1924V3.80761L9.1924 0ZM6.50009 11.2168C6.11353 11.2168 5.80036 10.9034 5.80036 10.5169C5.80036 10.1305 6.11353 9.81715 6.50009 9.81715C6.88665 9.81715 7.19981 10.1305 7.19981 10.5169C7.19981 10.9034 6.88665 11.2168 6.50009 11.2168ZM7.19981 8.3616C7.19981 8.74799 6.88665 9.06133 6.50009 9.06133C6.11353 9.06133 5.80036 8.74799 5.80036 8.36143V2.48312C5.80036 2.09656 6.1137 1.78322 6.50009 1.78322C6.88665 1.78322 7.19981 2.09656 7.19981 2.48312V8.3616Z",
    fill: "#007AA6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueAlert);
export default __webpack_public_path__ + "static/media/blue-alert.f9f6e59b2054adfb4ccd00155719cfea.svg";
export { ForwardRef as ReactComponent };